"use client";

import { type ReactNode } from "react";
import { APIProvider } from "@vis.gl/react-google-maps";
import { config } from "@/config";

type MapProviderProps = {
  children: ReactNode;
};

export const MapProvider = ({ children }: MapProviderProps) => {
  return (
    <APIProvider apiKey={config.google.maps} libraries={["marker"]}>
      {children}
    </APIProvider>
  );
};
